export const checkbox = {
  colorScheme: {
    light: {
      background: '#F4F7FE',
      checked: {
        background: 'var(--liga-primary-color)',
        hover: {
          background: 'var(--liga-primary-color)'
        }
      },
      border: {
        color: 'var(--liga-primary-color)'
      }
    },
    dark: {
      background: 'red',
      checked: {
        background: 'var(--liga-primary-color)',
        hover: {
          background: 'var(--liga-primary-color)'
        }
      },
      border: {
        color: 'var(--liga-primary-color)'
      }
    }
  }


}
